import React, { useState } from 'react'
import cn, { Argument as ClassName } from 'classnames'
import { Button } from 'primereact/button'

import { CurrentUser } from '../../../lib/currentUser'
import useText from '../../../common/hooks/useText'
import { Input } from '../../../common/uikit/Input'

export type PasswordChange = {
    currentPassword: string
    newPassword: string
    passwordCompare: string
}

export type UserProfileChangePasswordProps = {
    user: CurrentUser
    className?: ClassName
    style?: React.CSSProperties
    onChange: (obj: { [k: string]: PasswordChange }) => void
    openPasswordChange: boolean
    setOpenPasswordChange: (open: boolean) => void
}

const emptyPasswordChange = (): PasswordChange => ({
    currentPassword: '',
    newPassword: '',
    passwordCompare: '',
})

export function UserProfileChangePassword({
    className,
    style,
    onChange,
    openPasswordChange,
    setOpenPasswordChange,
}: UserProfileChangePasswordProps): React.ReactElement {
    const text = useText()
    const [passwordChange, setPasswordChange] = useState<PasswordChange>(emptyPasswordChange)

    const openForm = () => {
        setPasswordChange(emptyPasswordChange())
        setOpenPasswordChange(true)
    }

    return (
        <div className={cn('flex flex-column', className)} style={style}>
            {!openPasswordChange && (
                <Button
                    type="button"
                    label={text('lblChangePasswordLink')}
                    icon="pi pi-lock"
                    text
                    severity="info"
                    className="align-self-start px-0"
                    onClick={openForm}
                    data-testid="openPasswordChange"
                />
            )}
            {openPasswordChange && (
                <div className="flex flex-column gap-3" data-testid="passwordChange">
                    <h3 className="m-0 text-lg font-semibold">{text('lblChangingPassword')}</h3>
                    <Input
                        id="currentPassword"
                        label={text('lblCurrentPasswordField')}
                        type="password"
                        onChange={(e) => setPasswordChange((prev) => ({ ...prev, currentPassword: e.target.value }))}
                        onBlur={() => onChange({ passwordChange: passwordChange })}
                        data-testid="currentPassword"
                        className="w-full md:w-20rem"
                    />
                    <div className="flex flex-column md:flex-row gap-3">
                        <Input
                            id="newPassword"
                            label={text('lblNewPasswordField')}
                            type="password"
                            onChange={(e) => setPasswordChange((prev) => ({ ...prev, newPassword: e.target.value }))}
                            onBlur={() => onChange({ passwordChange: passwordChange })}
                            minLength={8}
                            data-testid="newPassword"
                            className="flex-1"
                        />
                        <Input
                            id="passwordCompare"
                            label={text('lblConfirmPasswordField')}
                            type="password"
                            onChange={(e) =>
                                setPasswordChange((prev) => ({ ...prev, passwordCompare: e.target.value }))
                            }
                            onBlur={() => onChange({ passwordChange: passwordChange })}
                            data-testid="passwordCompare"
                            className="flex-1"
                        />
                    </div>
                </div>
            )}
        </div>
    )
}
